export const LOGS_DETAIL_PAGE = {
  BACK_TO_LOGS: 'Back to Logs',
} as const;

export const APP_HEADER = {
  LOGOUT: 'Logout',
  LOGOUT_SUCCESS: 'You have been logged out successfully!',
  LOGOUT_ERROR: 'Error in logging out! Please try again later.',
  DEFAULT_USER_NAME: 'User',
  DEFAULT_USER_INITIAL: 'U',
  LOGIN_REDIRECT_PATH: '/login',
} as const;

export const PAGE_HEADING = {
  SEPARATOR: '|',
} as const;

export const EMPLOYEE_MASTER_PAGE = {
  TITLE_SECTION: 'Employee Master',
  DASHBOARD: 'Dashboard',
  SNAPSHOT: 'Snapshot',
  LOGS: 'Logs',
} as const;

export const EPMS_LOGS_PAGE = {
  TITLE_SECTION: EMPLOYEE_MASTER_PAGE.TITLE_SECTION,
  TITLE: EMPLOYEE_MASTER_PAGE.LOGS,
  LOGIN_LOGS_TITLE: 'Login Logs',
  DOWNLOAD_LOGS_TITLE: 'Download Logs',
  REASON_LOGS_TITLE: 'Reason Logs',
  LOG_DETAIL_TITLES: {
    loginLogs: 'Login Logs',
    accessLogs: 'Download Logs',
    reasonLogs: 'Reason Logs',
  } as Record<string, string>,
  INCOMPLETE_DATE_RANGE: 'Please select a complete Date Range!',
  ACTION_FAILED: 'Failed to {action} logs. Please try again.',
  DEFAULT_WEEK_RANGE_DAYS: 7,
  DEFAULT_REASON_RANGE_MONTHS: 6,
} as const;

export const CONSTANTS = {
  ACCESS_LOGS: 'accessLogs',
  LOGIN_LOGS: 'loginLogs',
  REASON_LOGS: 'reasonLogs',
  ACCESS_LOGS_FILENAME: 'Access_Log',
  LOGIN_LOGS_FILENAME: 'Login_Log',
  REASON_LOGS_FILENAME: 'Reason_Log',
  EMPLOYEE_MASTER_DASHBOARD: 'EMPLOYEE_MASTER_DASHBOARD1',
  EMPLOYEE_MASTER_SNAPSHOT: 'EMPLOYEE_MASTER_SNAPSHOT',
  EMPLOYEE_MASTER_SNAPSHOT_LOGS: 'EMPLOYEE_MASTER_SNAPSHOT_LOGS',
  AUTO_PROVISIONING_PROHANCE: 'AUTO_PROVISIONING_PROHANCE',
  AUTO_PROVISIONING_PIXIE: 'AUTO_PROVISIONING_PIXIE',
  FALCON_LOGS: 'FALCON_LOGS',
  PROHANCE: 'Prohance',
  FALCON: 'Falcon',
  CAMPAIGN: 'Campaign',
  GROUP: 'Group',
  DATABASE: 'Database',
  MANAGEJOBS: 'ManageJobs',
} as const;

export const EPMS_LOGS_CARDS = [
  { title: EPMS_LOGS_PAGE.LOGIN_LOGS_TITLE, logKey: CONSTANTS.LOGIN_LOGS },
  { title: EPMS_LOGS_PAGE.DOWNLOAD_LOGS_TITLE, logKey: CONSTANTS.ACCESS_LOGS },
  { title: EPMS_LOGS_PAGE.REASON_LOGS_TITLE, logKey: CONSTANTS.REASON_LOGS },
] as const;

export const AUTO_PROVISIONING_PAGES = {
  TITLE_SECTION: 'Auto Provisioning',
  PROHANCE: 'Prohance',
  MANAGE_JOBS: 'Manage Jobs',
  MAESTRO: 'Maestro',
  PIXIE: 'Pixie',
} as const;

export const PAGE_NOT_FOUND = {
  TITLE: 'Oops! Page Not Found',
  MESSAGE:
    "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. Let's get you back on track!",
  BTN_GO_HOME: 'Go Home',
  BTN_GO_BACK: 'Go Back',
} as const;

export const FALCON_LOGS_PAGE = {
  TITLE_SECTION: CONSTANTS.FALCON,
  TITLE: 'Logs',
  DOWNLOAD_LOGS_TITLE: 'Download Logs',
  INCOMPLETE_SELECTION: 'Please select database and a complete date range.',
  ACTION_FAILED: 'Failed to {action} logs. Please try again.',
  DEFAULT_RANGE_DAYS: 7,
} as const;

export const BREAKPOINT = {
  LG: 1024,
} as const;
export const MetaTitle = {
  Login: '',
  Falcon: '- Falcon',
  Prohance: '- Prohance',
  ProhanceCondition: '- Prohance Condition Filters',
  FalconCondition: '- Falcon Condition Filters',
  Dashboard: '- Dashboard',
  Snapshot: '- Snapshot',
  Logs: '- Logs',
  LogsDetails: '- Logs Details',
  FalconLogs: '- Falcon Logs',
  FalconLogsDetails: '- Falcon Logs Details',
} as const;

export const DASHBOARD = {
  DOWNLOADS_BY_FUNCTION: 'downloadsByFunction',
  TOP_FUNTIONS: 'topFunctions',
  DOWNLOADS_BY_USER: 'downloadsByUser',
  DOWNLOADS_BY_SITE: 'downloadsBySite',
  RECENT_ACTIVITY: 'recentActivity',
  RECENT_DOWNLOAD_REASONS: 'recentDownloadReasons',
  DOWNLOADS_BY_CAMPAIGN: 'downloadsByCampaign',
} as const;

export const DASHBOARD_PAGE = {
  DEFAULT_RANGE_DAYS: 7,
  METRICS: {
    TOTAL_LOGINS: 'Total Logins',
    TOTAL_DOWNLOADS: 'Total Downloads',
    REASONS: 'Reasons',
    REASON_PROVIDED: 'Provided :',
    REASON_NOT_PROVIDED: 'Not Provided :',
    REASON_TOOLTIP: 'Reason provided by Employee while downloading Snapshot file!',
  },
  CHARTS: {
    DOWNLOADS_BY_FUNCTION: 'Downloads by Function',
    TOP_10_FUNCTIONS: 'Top 10 Functions',
    TOP_DOWNLOADS_BY_USER: 'Top Downloads by User',
    DOWNLOADS_BY_SITE: 'Downloads by Site',
    RECENT_ACTIVITY: 'Recent Activity',
    RECENT_DOWNLOAD_REASONS: 'Recent Download Reasons',
    DOWNLOADS_BY_CAMPAIGN: 'Downloads by Campaign',
  },
  TABLE_COLUMNS: {
    FUNCTION_NAME: 'Function Name',
    SITE_NAME: 'Site Name',
    TOTAL_DOWNLOADS: 'Total Downloads',
  },
  EXPORT: {
    TOOLTIP: 'Export to CSV',
    DOWNLOADS_BY_FUNCTION: 'DOWNLOADS_BY_FUNCTION',
    TOP_FUNCTIONS: 'TOP_FUNCTIONS',
    DOWNLOADS_BY_USER: 'DOWNLOADS_BY_USER',
    DOWNLOADS_BY_SITE: 'DOWNLOADS_BY_SITE',
    RECENT_ACTIVITY: 'RECENT_ACTIVITY',
    RECENT_DOWNLOAD_REASONS: 'RECENT_DOWNLOAD_REASONS',
    DOWNLOADS_BY_CAMPAIGN: 'DOWNLOADS_BY_CAMPAIGN',
  },
} as const;

export const HEADERS_FOR_FUNCTION_DOWNLOADS = [
  { label: 'Function', key: 'position' },
  { label: 'Downloads', key: 'downloads' },
];

export const HEADERS_FOR_USER_DOWNLOADS = [
  { label: 'User Name', key: 'position' },
  { label: 'Downloads', key: 'downloads' },
];

export const HEADERS_FOR_SITE_DOWNLOADS = [
  { label: 'Site', key: 'site' },
  { label: 'Downloads', key: 'downloads' },
];

export const HEADERS_FOR_RECENT_ACTIVITY = [
  { label: 'User Name', key: 'user_name' },
  { label: 'Activity Time', key: 'created_at' },
];

export const HEADERS_FOR_RECENT_DOWNLOAD_REASONS = [
  { label: 'User Name', key: 'user_name' },
  { label: 'Reason', key: 'reasons_reason' },
  { label: 'Activity Time', key: 'updated_at' },
];

export const HEADERS_FOR_CAMPAIGN_DOWNLOADS = [
  { label: 'Campaign', key: 'position' },
  { label: 'Downloads', key: 'downloads' },
];

export const HEADERS_FOR_SNAPSHOT_EXPORT = [
  { label: 'EMPLOYEE ID', key: 'employee_id' },
  { label: 'EMAIL', key: 'email' },
  { label: 'FULL NAME', key: 'full_name' },
  { label: 'HIRE DATE', key: 'hire_date' },
  { label: 'POSITION JOB DESCRIPTION', key: 'position_job_description' },
  { label: 'CAMPAIGN', key: 'campaign' },
  { label: 'LOB', key: 'lob' },
  { label: 'SITE', key: 'site' },
  { label: 'IS ID', key: 'isid' },
  { label: 'IS FIRST NAME', key: 'is_first_name' },
  { label: 'IS LAST NAME', key: 'is_last_name' },
  { label: 'OPERATIONS MANAGER', key: 'operations_manager' },
  { label: 'SENIOR OPERATIONS MANAGER', key: 'senior_operations_manager' },
  { label: 'DEPARTMENT', key: 'department' },
  { label: 'WORK SITE STATUS', key: 'work_site_status' },
  { label: 'ALTERNATE CLIENT EMAIL', key: 'alternate_client_email_address' },
];

/** Custom display labels for snapshot API fields not in HEADERS_FOR_SNAPSHOT_EXPORT. */
export const SNAPSHOT_COLUMN_LABEL_OVERRIDES: Record<string, string> = {
  alternate_client_email_address: 'EMAIL',
};

export const getSnapshotColumnLabel = (key: string): string => {
  const normalizedKey = key
    .trim()
    .replace(/\s+/g, '_')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toLowerCase();

  const override = SNAPSHOT_COLUMN_LABEL_OVERRIDES[normalizedKey];
  if (override) return override;

  const knownHeader = HEADERS_FOR_SNAPSHOT_EXPORT.find(
    (header) => header.key === key || header.key === normalizedKey
  );
  if (knownHeader) return knownHeader.label;

  return key.replace(/_/g, ' ').trim().toUpperCase();
};

export const CLIENT_PROHANCE = 'PROHANCE';

export const AUTO_PROVISIONING_CLIENT = {
  PROHANCE: 'PROHANCE',
  FALCON: 'PIXIEBRIX',
} as const;

export const JOB_TYPE = {
  PROHANCE_AUTO_PROVISIONING: 'PROHANCE_AUTO_PROVISIONING',
  PIXIEBRIX_AUTO_SYNC: 'PIXIEBRIX_AUTO_SYNC',
  PIXIEBRIX_CAMPAIGN_SYNC: 'PIXIEBRIX_CAMPAIGN_SYNC',
  PIXIEBRIX_GROUP_SYNC: 'PIXIEBRIX_GROUP_SYNC',
  PIXIEBRIX_TEAM_LEADER_SYNC: 'PIXIEBRIX_DB_DATA_SYNC',
} as const;

export const CRON_JOB_NAME = {
  EMPLOYEE_MASTER_SYNC: 'EmployeeMasterSyncJob',
  AD_MANAGER_SYNC: 'AdManagerSyncJob',
  PIXIEBRIX_TEAM_LEAD_SYNC: 'PixiebrixDBDataSynchJob',
  PIXIEBRIX_CAMPAIGN_SYNC: 'PixiebrixCampaignSynchJob',
  PIXIEBRIX_GROUP_SYNC: 'PixiebrixGroupSynchJob',
  AP_PROHANCE_SYNC: 'ProhanceSynchJob',
  AP_FALCON_SYNC: 'PixiebrixSynchJob',
} as const;

export const JOB_STATUS = {
  STARTED: 'Started',
  ERROR: 'Error',
  INPROGRESS: 'InProgress',
  FINISHED: 'Finished',
} as const;

export const FALCONDATATYPE = [
  { key: 'CAMPAIGN', label: 'Campaign' },
  { key: 'GROUP', label: 'Group' },
  { key: 'DATABASE', label: 'Database' },
];

export const CronExpression = [
  { label: 'EVERY_30_MINUTES', key: '0 */30 * * * *' },
  { label: 'EVERY_HOUR', key: '0 0-23/1 * * *' },
  { label: 'EVERY_2_HOURS', key: '0 0-23/2 * * *' },
  { label: 'EVERY_3_HOURS', key: '0 0-23/3 * * *' },
  { label: 'EVERY_4_HOURS', key: '0 0-23/4 * * *' },
  { label: 'EVERY_5_HOURS', key: '0 0-23/5 * * *' },
  { label: 'EVERY_6_HOURS', key: '0 0-23/6 * * *' },
  { label: 'EVERY_7_HOURS', key: '0 0-23/7 * * *' },
  { label: 'EVERY_8_HOURS', key: '0 0-23/8 * * *' },
  { label: 'EVERY_9_HOURS', key: '0 0-23/9 * * *' },
  { label: 'EVERY_10_HOURS', key: '0 0-23/10 * * *' },
  { label: 'EVERY_11_HOURS', key: '0 0-23/11 * * *' },
  { label: 'EVERY_12_HOURS', key: '0 0-23/12 * * *' },
  { label: 'EVERY_DAY_AT_1AM', key: '0 01 * * *' },
  { label: 'EVERY_DAY_AT_2AM', key: '0 02 * * *' },
  { label: 'EVERY_DAY_AT_3AM', key: '0 03 * * *' },
  { label: 'EVERY_DAY_AT_4AM', key: '0 04 * * *' },
  { label: 'EVERY_DAY_AT_5AM', key: '0 05 * * *' },
  { label: 'EVERY_DAY_AT_6AM', key: '0 06 * * *' },
  { label: 'EVERY_DAY_AT_7AM', key: '0 07 * * *' },
  { label: 'EVERY_DAY_AT_8AM', key: '0 08 * * *' },
  { label: 'EVERY_DAY_AT_9AM', key: '0 09 * * *' },
  { label: 'EVERY_DAY_AT_10AM', key: '0 10 * * *' },
  { label: 'EVERY_DAY_AT_11AM', key: '0 11 * * *' },
  { label: 'EVERY_DAY_AT_NOON', key: '0 12 * * *' },
  { label: 'EVERY_DAY_AT_1PM', key: '0 13 * * *' },
  { label: 'EVERY_DAY_AT_2PM', key: '0 14 * * *' },
  { label: 'EVERY_DAY_AT_3PM', key: '0 15 * * *' },
  { label: 'EVERY_DAY_AT_4PM', key: '0 16 * * *' },
  { label: 'EVERY_DAY_AT_5PM', key: '0 17 * * *' },
  { label: 'EVERY_DAY_AT_6PM', key: '0 18 * * *' },
  { label: 'EVERY_DAY_AT_7PM', key: '0 19 * * *' },
  { label: 'EVERY_DAY_AT_8PM', key: '0 20 * * *' },
  { label: 'EVERY_DAY_AT_9PM', key: '0 21 * * *' },
  { label: 'EVERY_DAY_AT_10PM', key: '0 22 * * *' },
  { label: 'EVERY_DAY_AT_11PM', key: '0 23 * * *' },
  { label: 'EVERY_DAY_AT_MIDNIGHT', key: '0 0 * * *' },
  { label: 'EVERY_WEEK', key: '0 0 * * 0' },
  { label: 'EVERY_WEEKDAY', key: '0 0 * * 1-5' },
  { label: 'EVERY_WEEKEND', key: '0 0 * * 6,0' },
  { label: 'EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT', key: '0 0 1 * *' },
  { label: 'EVERY_1ST_DAY_OF_MONTH_AT_NOON', key: '0 12 1 * *' },
  { label: 'EVERY_2ND_HOUR', key: '0 */2 * * *' },
  { label: 'EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM', key: '0 1-23/2 * * *' },
  { label: 'EVERY_2ND_MONTH', key: '0 0 1 */2 *' },
  { label: 'EVERY_QUARTER', key: '0 0 1 */3 *' },
  { label: 'EVERY_6_MONTHS', key: '0 0 1 */6 *' },
  { label: 'EVERY_YEAR', key: '0 0 1 0 *' },
  { label: 'EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM', key: '0 */30 9-17 * * *' },
  { label: 'EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM', key: '0 */30 9-18 * * *' },
  { label: 'EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM', key: '0 */30 10-19 * * *' },
  { label: 'MONDAY_TO_FRIDAY_AT_1AM', key: '0 0 01 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_2AM', key: '0 0 02 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_3AM', key: '0 0 03 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_4AM', key: '0 0 04 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_5AM', key: '0 0 05 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_6AM', key: '0 0 06 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_7AM', key: '0 0 07 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_8AM', key: '0 0 08 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_9AM', key: '0 0 09 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_09_30AM', key: '0 30 09 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_10AM', key: '0 0 10 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_11AM', key: '0 0 11 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_11_30AM', key: '0 30 11 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_12PM', key: '0 0 12 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_1PM', key: '0 0 13 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_2PM', key: '0 0 14 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_3PM', key: '0 0 15 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_4PM', key: '0 0 16 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_5PM', key: '0 0 17 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_6PM', key: '0 0 18 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_7PM', key: '0 0 19 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_8PM', key: '0 0 20 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_9PM', key: '0 0 21 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_10PM', key: '0 0 22 * * 1-5' },
  { label: 'MONDAY_TO_FRIDAY_AT_11PM', key: '0 0 23 * * 1-5' },
];

export const NON_GLOBAL_JOBS = ['PIXIEBRIX'];

export const APPLICATION_LOCAL_STORAGE = {
  REFRESH_TOKEN: 'refreshToken',
  TOKEN_TIME_STAMP: 'tokenTimestamp',
  SESSION_TIMEOUT_IN_MILLI_SECONDS: 'sessionTimeoutInMilliseconds',
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN_LAST_UPDATED_AT: 'refreshTokenLastUpdatedAt',
  PING_ACCESS_TOKEN: 'pingAccessToken',
  SESSION_TIMEOUT: 'sessionTimeOut',
} as const;

// TODO(security): Token refresh interval should be configured via environment variable, not hardcoded
export const AUTH_TOKEN_GENERATION_TIME_IN_SEC = 5000;

export const REDIRECTION_PAGE = {
  LOGIN_PAGE: '/login',
} as const;

export const STATUS_CODE = {
  OK: 200,
  BAD_REQUEST: 403,
  INTERNAL_SERVER_ERROR: 500,
  CREATED: 201,
  UNAUTHORIZED: 401,
  PRECONDITION_FAILED: 412,
} as const;

export const FIELD_DATA_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  TIME: 'time',
} as const;

export const ADD_PROJECT_MODAL_CONSTANTS = {
  modalTitle: 'Add New Project',
  projectNameLabel: 'Project Name',
  projectDescriptionLabel: 'Project Description',
  projectNamePlaceholder: 'Enter project name',
  projectDescriptionPlaceholder: 'Enter project description',
  requiredMark: '*',
  createButtonLabel: 'Create',
  creatingButtonLabel: 'Creating...',
  enabledLabel: 'Enabled',
  disabledLabel: 'Disabled',
  statusLabel: 'Status',
  successMessage: 'Project added successfully!',
  errorMessage: 'Something went wrong',
} as const;

export const DYNAMIC_FORM_MODAL_CONSTANTS = {
  dialogMaxWidth: 'sm' as const,
  jobRunSuccessMsg: 'Job started successfully!',
  jobRunFailedMsg: 'Failed to start job:',
  submitButtonLabel: 'Submit',
  configTitle: 'Configuration Setting',
  runTitle: 'Job Run Details',
  disclaimerText:
    'Please review all values carefully before running the job. Changes cannot be undone.',
} as const;

export const RUN_JOB_CONFIRMATION_CONSTANTS = {
  modalTitle: 'Run Job',
  confirmMessage: 'This operation will take a few minutes to complete, please wait!',
  yesButtonLabel: 'Yes',
  noButtonLabel: 'No',
} as const;

export const CRON_MODAL_CONSTANTS = {
  modalTitle: 'Configure Cron',
  saveButtonLabel: 'Save Changes',
} as const;

export const CONNECTION_DETAILS_CONSTANTS = {
  FIELDS: {
    NAME: 'name',
    AUTH_TYPE: 'authType',
    CLIENT_ID: 'clientId',
  },
  LABELS: {
    NAME: 'Connection name',
    AUTH_TYPE: 'Auth type',
    CLIENT_ID: 'Client ID',
  },
  HELPER_TEXTS: {
    NAME: 'Name your connection. You can reuse it in other recipes.',
    AUTH_TYPE: 'Select authentication type used to connect.',
    CLIENT_ID: 'To create client ID, register an application.',
  },
  BUTTON_TEXT: {
    EDIT: 'Edit',
    DELETE: 'Delete',
    SAVE: 'Save',
    CANCEL: 'Cancel',
  },
} as const;

export const PROJECT_DETAILS_CONSTANTS = {
  TABS: ['Jobs'],
  TAB_NAMES: {
    JOBS: 'Jobs',
    CONNECTORS: 'Connectors',
  },
  BUTTON_LABELS: {
    ADD_JOB: 'Add Job',
    ADD_CONNECTION: 'Add Connection',
  },
  NO_PROJECT_SELECTED_MESSAGE: 'No project selected.',
} as const;

export const JOBS_CONSTANTS = {
  ITEMS_PER_PAGE: 10,
  SEARCH: {
    PLACEHOLDER: 'Search Jobs',
  },
  STATUS_FILTER_OPTIONS: [
    { value: '', label: 'All status' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'InActive' },
  ],
  PAGINATION: {
    SHOWING_TEXT: (start: number, end: number, total: number) =>
      `Showing ${start}–${end} of ${total} jobs`,
    SYNC_BUTTON_LABEL: 'Sync Now',
    PREVIOUS: '<',
    NEXT: '>',
  },
  FILTER_STATUS_MAPPING: {
    Active: 0,
    Inactive: 1,
  } as Record<string, number>,
} as const;

export const JOBSCARD_CONSTANTS = {
  MENU_ACTIONS: {
    START: 'start',
    CONFIG: 'config',
    EDIT: 'edit',
  },
  MENU_LABELS: {
    RUN_JOB: 'Run Job',
    CONFIG: 'Config',
    EDIT: 'Edit',
  },
  MESSAGES: {
    JOB_STARTED_SUCCESS: 'Job started successfully!',
  },
} as const;

export const CRON_JOB_CONSTANTS = {
  TABS: ['Execution Logs'],
  NOLOGFOUNDTITLE: 'No Logs found',
  NOLOGFOUNDSUBTEXT: 'Try adjusting your search or filters',
} as const;

export const AddJobFormConstants = {
  title: {
    create: 'Create Job',
    edit: 'Edit Job',
  },
  labels: {
    jobName: 'Job Name',
    schedule: 'Schedule (Cron)',
    timezone: 'Timezone',
    description: 'Description',
    enabled: 'Enabled',
    disabled: 'Disabled',
    cronHint: 'Specify the cron expression.',
    cronConfigure: 'Configure Crons',
  },
  placeholders: {
    jobName: 'Nightly database sync',
    description: 'Optional job description...',
  },
  errors: {
    jobName: 'Job name is required',
    cron: 'Cron schedule is required',
    timezone: 'Timezone is required',
  },
  button: {
    create: 'Create Job',
    update: 'Update Job',
    creating: 'Creating...',
    updating: 'Updating...',
  },
  timezones: [
    { label: 'UTC', value: 'UTC' },
    { label: 'Asia/Kolkata', value: 'Asia/Kolkata' },
    { label: 'America/New_York', value: 'America/New_York' },
  ],
  getBreadcrumbOverrides: (title: string, jobName?: string) => ({
    '/projects': {
      label: 'Projects',
      path: '/projects/overview',
    },
    [`/projects/${encodeURIComponent(title)}`]: {
      label: title,
      disabled: false,
    },
    ...(jobName && {
      [`/projects/${encodeURIComponent(title)}/${encodeURIComponent(jobName)}`]: {
        label: jobName,
        disabled: false,
      },
    }),
  }),
} as const;

export const NoJobsFoundConstants = {
  title: 'No jobs found',
  subtext: 'Try adjusting your search or filters',
} as const;

export const projectOverviewConstants = {
  header: {
    title: 'Automation Projects',
    subtitle: 'Manage your cron job projects',
  },
  searchBar: {
    placeholder: 'Search projects',
  },
  noProjectsFound: {
    message: 'No projects found',
  },
  showingText: (start: number, end: number, total: number) =>
    `Showing ${total === 0 ? 0 : start}–${end} of ${total} projects`,
} as const;

export const projectCardConstants = {
  statusLabels: {
    active: 'Active',
    inactive: 'Inactive',
  },
  labels: {
    jobs: 'Jobs',
    connections: 'Connections',
    created: 'Created',
  },
} as const;
